<mat-toolbar color="primary">
    <mat-toolbar-row>
        <button mat-icon-button>
            <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
        </button>

        <a class="logo-link" routerLink="/app" aria-label="Go to dashboard">
            <img class="fire-survey-pro-logo hide-on-mobile" src="assets\images\logo\FSP_Orange_BG.png" alt="Fire Survey Pro Logo" />
        </a>

        <span class="flex-spacer"></span>

        @if (authService.credits < (authService.getTenantSetting('low_credit_warning')?.payload ?? 400) && authService.credits >= 0) {
            <button
                    class="pill d-none d-md-inline"
                    mat-raised-button
                    (click)="purchaseCredits()"
                    style="margin-right: 10px; background-color: #ffee58 !important; color: black;"
            >
                <mat-icon style="margin-right: 5px; line-height: 23px; font-size: 20px;">warning</mat-icon>
                Low Credits
            </button>
        }

        <button mat-raised-button (click)="purchaseCredits()" color="accent" tourAnchor="dashboard.credits" style="margin-right: 10px;">
            <mat-icon style="margin-right: 5px; vertical-align: middle;">toll</mat-icon>
            <span style="vertical-align: middle;">{{ authService.credits | number:'' }}</span>
        </button>

        <!-- <button ngIf="usersService?.user?.tenants.length > 1; else singleTenant" mat-button class="float-end" [matMenuTriggerFor]="tenantMenu">
            <mat-icon>arrow_drop_down</mat-icon>
            {{ authService.tenant.name }}
        </button>

        <mat-menu #tenantMenu="matMenu" ngIf="usersService?.user?.tenants.length > 1">
            <button *ngFor="let tenant of usersService.user.tenants" mat-menu-item (click)="switchTenant(tenant)">
                <span>{{ tenant.name }}</span>
            </button>
        </mat-menu> -->

        @if (showDeveloperMenu) {
            <button class="hide-on-mobile" mat-icon-button [matMenuTriggerFor]="developerMenu">
                <mat-icon>terminal</mat-icon>
            </button>

            <mat-menu #developerMenu="matMenu">
                <button mat-menu-item (click)="openImpersonateDialog()">
                    <mat-icon>manage_search</mat-icon>
                    Impersonate User
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="resetTours()">
                    <mat-icon>tour</mat-icon>
                    Reset Tours
                </button>
                <button mat-menu-item (click)="throwTestError()">
                    <mat-icon>bug_report</mat-icon>
                    Test Sentry Error
                </button>
            </mat-menu>
        }

        <button class="hide-on-mobile" mat-icon-button [matMenuTriggerFor]="helpMenu" tourAnchor="dashboard.help">
            <mat-icon>help</mat-icon>
        </button>

        <mat-menu #helpMenu="matMenu">
            <mat-action-list>
                <mat-list-item (click)="openExternalLink('help')">
                    <mat-icon matListItemIcon>import_contacts</mat-icon>
                    <span matListItemTitle>Help Guide</span>
                    <span matListItemLine>Click here to view support documentation for the Fire Survey Pro app.</span>
                </mat-list-item>

                <mat-list-item (click)="openExternalLink('ticket')">
                    <mat-icon matListItemIcon>support</mat-icon>
                    <span matListItemTitle>Having Issues?</span>
                    <span matListItemLine>Click here to raise a support ticket.</span>
                </mat-list-item>

                <mat-list-item (click)="openExternalLink('email')">
                    <mat-icon matListItemIcon>email</mat-icon>
                    <span matListItemTitle>Email Us</span>
                    <span matListItemLine>support&#64;firesurveypro.co.uk</span>
                </mat-list-item>

                <mat-list-item (click)="openExternalLink('phone')">
                    <mat-icon matListItemIcon>phone</mat-icon>
                    <span matListItemTitle>Call Us</span>
                    <span matListItemLine>01482 425516</span>
                </mat-list-item>
            </mat-action-list>
        </mat-menu>

        <button mat-button class="float-end" [matMenuTriggerFor]="userMenu" tourAnchor="dashboard.user-menu">
            <mat-icon class="me-2" style="font-size: 24px; width: 24px; height: 24px; line-height: 24px; vertical-align: middle;">account_circle</mat-icon>
            <div style="display: inline-block;">
                <span style="display: block; line-height: normal;">{{ authService.tenant.name }}</span> <span style="display: block; float: left; line-height: normal; font-weight: lighter;">{{ usersService.user.name }}</span>
            </div>
        </button>

        <mat-menu #userMenu="matMenu">
            <button mat-menu-item (click)="toggleTheme()">
                <mat-icon>{{ currentTheme === 'light-theme' ? 'dark_mode' : 'light_mode' }}</mat-icon>
                <span>{{ currentTheme === 'light-theme' ? 'Dark Mode' : 'Light Mode' }}</span>
            </button>

            <mat-divider></mat-divider>

            <button mat-menu-item (click)="openUserPreferences()">
                <mat-icon>manage_accounts</mat-icon>
                <span>User Settings</span>
            </button>

            <mat-divider></mat-divider>

            <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Sign Out</span>
            </button>
        </mat-menu>
    </mat-toolbar-row>
</mat-toolbar>

@if (impersonationService.isImpersonating) {
    <div class="impersonation-banner">
        <span class="impersonation-message">
            <mat-icon>info</mat-icon>
            Acting as {{ impersonationService.impersonatedUserName || usersService.user?.name }}
            @if (impersonationService.impersonatedUserEmail) {
                ({{ impersonationService.impersonatedUserEmail }})
            }
        </span>
        <button mat-button class="stop-impersonation-button" (click)="stopImpersonating()">
            Stop Impersonating
        </button>
    </div>
}

<mat-sidenav-container [class.with-impersonation-banner]="impersonationService.isImpersonating">
    <!-- TODO: Need to confirm the behaviour of the opened expression -->
    <mat-sidenav class="side-bar-expanded" [mode]="(themeService.handset | async) ? 'side' : 'push'" [opened]="!!(themeService.handset | async)" tourAnchor="dashboard.navigation" #sidenav>
        <ng-scrollbar class="sidenav-scrollbar scrollbar" visibility="hover">
            <a class="logo-link hide-on-desktop" routerLink="/app" aria-label="Go to dashboard">
                <div class="login-logo"></div>
            </a>

            <mat-nav-list>
                <div mat-subheader>Navigation</div>
                @for (link of links; track link.url) {
                    @if ((link.permission ? (link.permission | hasPermission) : true) && (link.featureFlag ? featureFlags[link.featureFlag] : true)) {
                        <a
                                mat-list-item
                                routerLink="/{{ link.url }}"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: link.url === 'app'}"
                        >
                            <mat-icon matListItemIcon>{{ link.icon }}</mat-icon>
                            <span matListItemTitle class="nav-title-row">
                                <span>{{ link.name }}</span>
                                @if (link.badge !== undefined) { <span class="nav-count" [attr.aria-label]="link.badge + ' items overdue or due in the next 30 days'">{{ link.badge }}</span> }
                            </span>
                        </a>
                    }
                }
            </mat-nav-list>

            <mat-action-list>
                <mat-divider></mat-divider>
                <div mat-subheader>Support</div>

                <button mat-list-item (click)="purchaseCredits()">
                    <mat-icon matListItemIcon>toll</mat-icon>
                    <span matListItemTitle>Buy Credits</span>
                    <span matListItemLine>{{ authService.credits }}</span>
                </button>

                <button mat-list-item [matMenuTriggerFor]="helpMenu">
                    <mat-icon matListItemIcon>help</mat-icon>
                    <span matListItemTitle>Help Centre</span>
                </button>

                <mat-divider></mat-divider>
            </mat-action-list>

            <div class="app-store-icons mt-2" tourAnchor="dashboard.mobile">
                <a href="https://apps.apple.com/us/app/fire-survey-pro/id6479811537" target="_blank">
                    <img ngSrc="../../../assets/images/apple_appstore_icon.svg" alt="Apple App Store Icon" height="40" width="120" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=surveyorpro.firesurveypro" target="_blank">
                    <img ngSrc="../../../assets/images/android_appstore_icon.png" alt="Android App Store Icon" class="m-1" height="80" width="270" />
                </a>
            </div>
        </ng-scrollbar>
    </mat-sidenav>

    <mat-sidenav-content>
        <ng-scrollbar class="admin-scrollbar scrollbar" visibility="hover">
            <div class="admin-content-shell">
                <router-outlet></router-outlet>
            </div>
        </ng-scrollbar>
        <app-admin-footer></app-admin-footer>
    </mat-sidenav-content>
</mat-sidenav-container>

<div class="centered-tour-element" tourAnchor="dashboard.welcome"></div>
